// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"1dd4a8e4","526":"b5c10818","615":"7e4aa650","672":"86541799","875":"4db26e82","986":"4e03ef2f"}[chunkId] + ".chunk.js";
};